import React, { Component } from 'react';
import { connect } from 'react-redux';

import Dim from 'web/components/common/modal/common/Dim';
import { initModal, pushModal } from 'shared/actions/modal.action';

import {} from 'shared/actions/auth.action';
import ReviewModalMobile from 'web/components/reviewModalMobile/ReviewModalMobile';

@connect(
  state => ({
    review: state.shared.customer.review,
    modal: state.shared.modal,
  }),
  { initModal, pushModal },
)
class ReviewMobileContainer extends Component {
  setData = data => {
    this.props.pushModal({
      type: 'ReviewModalMobile',
      data: {
        ...data,
      },
    });
  };

  setIdx = idx => {
    this.setData({ idx });
  };

  render() {
    const { modal = {}, review } = this.props;
    const { data = {} } = modal;
    const { idx } = data;
    console.log('리뷰 모달 컨테이너', { review });
    return (
      <Dim onClick={this.props.initModal}>
        <ReviewModalMobile
          handleClose={this.props.initModal}
          modal={this.props.modal}
          list={review}
          idx={idx}
          setIdx={this.setIdx}
        />
      </Dim>
    );
  }
}

export default ReviewMobileContainer;
